import { render, staticRenderFns } from "./DeclarationDetails.vue?vue&type=template&id=440392f0&scoped=true"
import script from "./DeclarationDetails.vue?vue&type=script&lang=js"
export * from "./DeclarationDetails.vue?vue&type=script&lang=js"
import style0 from "./DeclarationDetails.vue?vue&type=style&index=0&id=440392f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440392f0",
  null
  
)

export default component.exports